module.exports = __webpack_public_path__ + "static/media/dish19.fc18f43a.jpg";